import {API_DRIVER} from "../configs/axios";

const SimOptionsService = {
    modifyEnablingClass: (body) => {
        return API_DRIVER.post(`/api/sim-options/extra-gb/change-status`, body)
    }
}

export default SimOptionsService
